module.exports = __webpack_public_path__ + "static/media/Logo.55162045.png";